<template >
  <div v-if="numResults < 20" class="q-ml-md"> 
    <div class="text-caption q-pa-sm">
      To get started, choose an option below
      <q-btn dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs['sectionHeader'].model = !infoDialogs['sectionHeader'].model" aria-label="Select an area help"/>
    </div>

    <div class="">
      <div class="row items-center q-ml-sm q-mb-sm">
        <q-icon name="edit" size="md" color="white" class="bg-black circle q-pa-xs"/>
        <div class="bg-grey-4 concave-left" style="width: 90%">
            <span class="text-bold q-pl-sm">Sketch or Upload an Area of Interest</span>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="row justify-center q-ma-md"><q-btn @click="startSketch" label="Sketch a Polygon" :class="drawingActive ? 'selButton' : ''"/></div>
          <div v-if="drawZoomWarn" class="text-center text-warning shadow-1 q-ml-md">Zoom in to at least zoom level 6 to draw a polygon</div>
        </div>
        <div class="col-6">
          <div class="row justify-center q-ma-md"><q-btn @click="polyUpload = !polyUpload" label="Upload a Polygon"/></div>
        </div>
      </div>
    </div>
    
    <div class="q-mt-lg">
      <div class="row items-center q-ml-sm q-mb-sm">
        <q-icon name="search" size="md" color="white" class="bg-black circle q-pa-xs"/>
        <div class="bg-grey-4 concave-left" style="width: 90%">
            <span class="text-bold q-pl-sm">Search a Predefined Area</span>
        </div>
      </div>
      <div v-if="!loadingPolyResult">
        <div class="row q-ml-lg" >
          <q-select style="width: 400px" ref="leaseSelect" dense rounded outlined v-model="lease" :options="leaseOptions" label="Wind Areas (Active & Proposed)" width="500" >
            <template v-slot:option="scope">
              <q-item
                v-if="scope.opt.header"
                :key="'header-' + scope.index"
                class="q-pa-none"
              >
                <q-item-section>
                  <q-item-label header class="header-style">{{ scope.opt.label }}</q-item-label>
                </q-item-section>
              </q-item>
              <q-item
                v-else
                :key="'option-' + scope.index"
                clickable
                @click="areaSelect(scope.opt, 'lease', leaseSelect)"
              >
                <q-item-section>
                  <q-item-label>{{ scope.opt.label }}</q-item-label>
                </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>
        <div class="row q-ml-lg q-mt-sm" >
          <q-select style="width: 400px" ref="transLineSelect" dense rounded outlined v-model="transLines" :options="transLinesOptions" label="Transmission Lines & Cables" width="500">
            <template v-slot:option="scope">
              <q-item
                v-if="scope.opt.header"
                :key="'header-' + scope.index"
                class="q-pa-none"
              >
                <q-item-section>
                  <q-item-label header class="header-style">{{ scope.opt.label }}</q-item-label>
                </q-item-section>
              </q-item>
              <q-item
                v-else
                :key="'option-' + scope.index"
                clickable
                @click="areaSelect(scope.opt, 'trans', transLineSelect)"
              >
                <q-item-section>
                  <q-item-label>{{ scope.opt.label }}</q-item-label>
                </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>
      
        <div class="row q-ml-lg q-mt-sm" >
          <q-select style="width: 400px" ref="otherPredefinedSelect" dense rounded outlined v-model="otherPredefined" :options="otherPredefinedOptions" label="Other Areas" width="500">
            <template v-slot:option="scope">
              <q-item
                v-if="scope.opt.header"
                :key="'header-' + scope.index"
                class="q-pa-none"
              >
                <q-item-section>
                  <q-item-label header class="header-style">{{ scope.opt.label }}</q-item-label>
                </q-item-section>
              </q-item>
              <q-item
                v-else
                :key="'option-' + scope.index"
                clickable
                @click="areaSelect(scope.opt, 'otherPredefined', otherPredefinedSelect)"
              >
                <q-item-section>
                  <q-item-label>{{ scope.opt.label }}</q-item-label>
                </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>
      </div>

      <div class="row justify-center" v-else>
        <q-spinner size="lg" color="secondary"/>
      </div>

    </div>


  </div>
  <div v-else class="q-ma-md">
    <div class="row justify-center q-mt-lg">
      <div class="col text-center">
        <q-icon name="warning" color="warning" size="lg"/>
        <div class="text-bold">You have reached the maximum number of AOIs.</div>
      </div>
    </div>
    <div class="q-pt-sm">You can select additional AOIs by refreshing the page or opening the tool in another browser tab.</div>
    <div class="q-pt-sm">To save these AOIs for future reference, click the "Download Map Link" button at the top right corner of the tool.</div>
  </div>

  <div class="q-mt-lg q-ml-md" >
    <div class="row items-center q-ml-sm q-mb-sm">
      <q-icon  v-svg="getIcon('spSelectV2')" size="md" color="white" class="bg-black circle q-pa-xs"/>
      <div class="bg-grey-4 concave-left" style="width: 90%">
          <span class="text-bold q-pl-sm">Select Species or Habitats of Interest</span>
      </div>
    </div>
    <div class="row q-ml-lg q-mt-sm" >
      <div class="col-6">
        <SpSpotSelect />
      </div>
      <div class="col-6">
        <HabSpotSelect />
      </div>
    </div>
  </div>

  <q-separator class="q-mt-xl"/>

  <q-dialog v-model="polyUpload">
    <PolyUpload/>
  </q-dialog>

  <div v-for="(infoObj, name) in infoDialogs" :key="name">
    <q-dialog v-model="infoObj.model">
        <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
    </q-dialog>
  </div>

</template>
<link rel='stylesheet' href='https://unpkg.com/maplibre-gl@4.5.2/dist/maplibre-gl.css' />
<script setup lang="ts">

import { ref, onMounted, onUnmounted, computed, watch } from "vue";
import { useRouter } from 'vue-router';
import { useMapItems } from "../composables/useMapItems"
import { useHelpers } from "../composables/useHelpers"
import { event } from 'vue-gtag'
import InfoDialog from './InfoDialog.vue'
import PolyUpload from './PolyUpload.vue'
import SpSpotSelect from "./SpSpotSelect.vue";
import HabSpotSelect from "./HabSpotSelect.vue";
import { planningOptions } from "../assets/planning_options.json" 
import { activeOptions } from  "../assets/active_options.json"
import { transmissionOptions } from "../assets/transmission_options.json"
import { otherOptions } from "../assets/other_options.json"
import 'maplibre-gl/dist/maplibre-gl.css';
import { useSvgIcon } from '../composables/useSvgIcon';

const { getIcon } = useSvgIcon();
const { setLoadingLease, getNextVersionNumber, setActiveSpSpotlight, setActiveHabSpotlight, setSiteNames, addSaveProcessedData, loadSavedProcessedData, setActivePane, setLoadedResults, setDrawZoomWarn, drawZoomWarn,  zoomToPolygon, cellData, queryParams, processedData, setQueryParams, setQuerying, draw, setDrawingActive, tileLayers, map,  activeLayerID, drawingActive, mapLoaded, toggleLayer, setUserPolygon } = useMapItems();
const { arrayFindObjectByProp, base64ToObj, logGAevent} = useHelpers();
const router = useRouter();


watch(mapLoaded, (nv, ov) =>{
  if (nv == true){
    // console.log(tileLayers)
    const flagsLayer = arrayFindObjectByProp(tileLayers.value, 'id', "FLAGS")
    toggleLayer(true, flagsLayer, null) // no version
  }
})

const infoDialogs = ref({
  sectionHeader : {
    pName: "Select an Area",
    model: false,
    text: "<div>The primary function of the Marine Mapping Tool is to summarize a wealth of ocean data for a given area of interest.  To begin a summary, either select a pre-defined area of interest from the list of Wind Lease Areas and Transmission Lines/Cables or create a custom area of interest by sketching a polygon or uploading a GIS polygon file.</div><div class='text-h6 q-pt-sm'>Species & Habitat Spotlights</div><div class=''>Alternately, ecoregion summary information is available for a subset of key bird species and coastal habitats. These summaries can be accessed from the 'Spotlight a Species' and 'Spotlight a Habitat' dropdown lists, respectively.</div>"
  }
})

const infoD = ref(false)
const polyUpload = ref(false)


watch(mapLoaded, (nv, ov) =>{
  // console.log(nv)
})

const startSketch = (e) =>{
  logGAevent("start_sketch", "", "")
  if (mapLoaded.value) {
    enableSketch()
  }
  else {
    watch(mapLoaded, (nv, ov) =>{
      if (nv){
        enableSketch()
      }
    }, { once: true })
  }
}

const enableSketch = () =>{
  if (map.value.getZoom() < 6) { setDrawZoomWarn(true) }

  if (!drawingActive.value) {
    // enable drawing
    if (!isControlAdded(draw.value)) {
      map.value.addControl(draw.value, 'top-right');
    }
    draw.value.changeMode('draw_polygon')
    setDrawingActive(true)
  }
  else {
    // disable drawing
    draw.value.changeMode('simple_select')
    map.value.removeControl(draw.value);
    setDrawingActive(false)
  }
}

const  isControlAdded = (control) => {
    const controls = map.value._controls || [];
    return controls.includes(control);
}

const lease = ref(null)
const leaseOptions = computed(() =>{
  const opts = []

  opts.push({header: true, label: 'Active'})
  activeOptions.forEach((option) =>{
    opts.push(option)
  })

  opts.push({header: true, label: 'Planning'})
  planningOptions.forEach((option) =>{
    opts.push(option)
  })

  return opts
})

const transLines = ref(null)
const transLinesOptions = ref(transmissionOptions)

const otherPredefined = ref(null)
const otherPredefinedOptions = ref(otherOptions)

const loadingPolyResult = ref(false)
// load a pre-defined polygon

const loadB64Poly = async () =>{
  setLoadingLease(true)
  // console.log(lease)

  // this is used to load a locally stored JSON file, but just the base64 data 
  // so instead using S3
  const modules = import.meta.glob('../polygons/*.json');

  const files = {};
  for (const [path, resolver] of Object.entries(modules)) {
    // console.log(path)
    const fileName = path.replace('../polygons/', '').replace('.json', '');
    const module = await resolver();
    files[fileName] = (module as { default: any }).default;

  }

  //the json includes the file name as key.  So if fileName == "lease1" JSON within it = {"lease1" :"b64--kjhkljgl"}
  const compressedB64 = files[savedPoly.value.value][savedPoly.value.value] 
  const savedObj = await base64ToObj(compressedB64)
          
  // console.log(savedObj)
  // if there was a species selected for spotlight, set that
  if (savedObj['spSpotlight']){
    setActiveSpSpotlight(savedObj['spSpotlight']);
  }

  if (savedObj['habSpotlight']){
    setActiveHabSpotlight(savedObj['habSpotlight']);
  }


  if (mapLoaded.value){
    addSaveProcessedData(savedObj);
  }
  else{
    watch(mapLoaded, (newValue, oldValue) => {
      addSaveProcessedData(savedObj);
    }, { once: true });
  }
  setLoadingLease(false)


  // clear the b64 query parameter
  // router.push("/results1/summary");
}

const loadPoly = async (lease) =>{
  // console.log("LOADING SAVED POLY")

  // downlaod the result JSON from S3.  Includes all results & the polygon geojson
  // Add a spinner
  setQuerying(true); // spinner on map
  loadingPolyResult.value = true; // spinner on lease selection
  const polyResult = await loadPolygonResultsFromS3(lease.value);
  loadingPolyResult.value = false;
  setQuerying(false);

  const version = getNextVersionNumber()
  setSiteNames(version, polyResult["1"].name)
  
  // all of the JSON files are item "1": created by clicking through all results 
  // for the polygon.  Then saved.  
  const userPoly = makeCleanJson(polyResult["1"].poly, version)
  setUserPolygon(userPoly, version)
  zoomToPolygon(userPoly) 

  // this is different from the regular set results.  
  // Just plugs in the whole reuslt object for the version number
  setLoadedResults(version, polyResult["1"])
  
  setActivePane('summary')
  router.push(`/results${version}`)
}


const loadPolygonResultsFromS3 = async (lease) =>{
  // console.log("importing polygons")
  const s3URL = `https://marinemap-v2.s3.amazonaws.com/${lease}.json`
  try {
    const fetchResponse = await fetch(s3URL);
    return await fetchResponse.json();
  } catch (err) {
    console.error('Error - ', err);
  }
}

const makeCleanJson = (content, version) =>{
    // console.log(content)
    const userPoly = {
        type: "FeatureCollection",
        features:[],
        id: `userPoly_${version}`
    } as any;
    content['features'].forEach((feat)=>{
        userPoly.features.push(feat)
    })
    return userPoly
}

const leaseSelect = ref(null)
const transLineSelect = ref(null)
const otherPredefinedSelect = ref(null)

const savedPoly = ref(null)
const areaSelect = (opt, options, select) =>{
  logGAevent("load_lease", opt, "")
  if (options === 'lease'){
    lease.value = opt;
  }

  else if (options === 'trans'){
    transLines.value = opt;
  }

  else if (options === 'otherPredefined'){
    otherPredefined.value = opt;
  }

  select.hidePopup();
  savedPoly.value = opt;
  loadB64Poly()
}

const polygons = ref({});
const loadPolygonResultsFromLocalJSON = async ()=>{
  // this was to load a locally stored JSON file, but the result JSON files can be too big
  // so instead using S3
  const modules = import.meta.glob('../polygons/*.json');
  const files = {};
  for (const [path, resolver] of Object.entries(modules)) {
    const fileName = path.replace('./polygons', '').replace('.json', '');
    const module = await resolver();
    files[fileName] = (module as { default: any }).default;
  }
  // console.log(files)
  polygons.value = files;
}

const numResults = computed(() =>{
  let n = 0
  for (const [key, obj] of Object.entries(processedData.value)) {
    if (parseInt(key) <= 100){ // big number, because could possibly delete a lot of AOIs
      n +=1
    }
  }
  return n
})

onMounted(async () => {
// console.log(cellData.value)

  // onMount add the user polygon for this version
  const userPolys = ["userPoly_1", "userPoly_2", "userPoly_3", "userPoly_4", "userPoly_5"]
  if (map.value && map.value.isStyleLoaded()){
    userPolys.forEach((poly) =>{
      if(map.value.getLayer(poly)) {
        map.value.removeLayer(poly)
        
        const outlinedPoly = poly + "_o"
        map.value.removeLayer(outlinedPoly)
        
        map.value.removeSource(poly)
      }
    })
  }
  if (activeLayerID.value){
    toggleLayer()
  }
})


onUnmounted( () =>{
  // turn off drawing
  try{
    // console.log(draw.value)
    draw.value.changeMode('simple_select')
    map.value.removeControl(draw.value);
    setDrawingActive(false)
  }
  catch(e){
    // console.log("no draw")
  }
});


</script>
<style scoped>
.text-small{
  font-size: x-small;
}
.pointer{
  cursor: pointer;
}
.border {
  border: 1px solid black;
}
.circle{
  border-radius:50%;
}
.selButton{
  color: white;
  background-color: black;
}
.concave-left{
  margin-left:-5px;
  float:left
}

</style>
